import { SearchBoxConfig } from '../../../models';
import { DeepPartial } from '../../../utils';

export const DEFAULT_SEARCH_BOX_CONFIG: DeepPartial<SearchBoxConfig> = {
  autofocus: true,
  instantSearch: {
    enabled: true
  }
};
